
































import {Vue, Component, Prop} from 'vue-property-decorator';
import {PostReviewsConfigurationsExcludedProductsExcelBulk} from 'supporter';
import {changeDateFormat} from '@/utils/dateUtils';
import {saveAs} from 'file-saver';


@Component
export default class ExcelUploadResult extends Vue {
  @Prop({required: true})
  private isShow!: boolean;

  @Prop({required: true})
  private result!: PostReviewsConfigurationsExcludedProductsExcelBulk;

  private async downloadFailExcel() {
    try {
      const result = await this.$api.getReviewsConfigurationsExcludedProductsExcelFailHistories({params: { historyId: this.result.failHistoryId}, responseType: 'arraybuffer'});
      const blob = new Blob([result.data], {type: result.headers['content-type']});
      const fileName = `Upload_Review_ProductNo_${changeDateFormat(new Date(), 'YYYYMMDD')}.xlsx`;
      saveAs(blob, fileName);

    } catch(err) {
      err?.result?.message && alert(err.result.message);
    }
  }

  private close() {
    this.$emit('closeModal');
  }
}
